module.exports = __webpack_public_path__ + "img/fwzt01_1.5253120.png";